import React, { useEffect, useState } from "react";
import "./App.css";
import SearchBar from "./components/searchBar";
import CardCanvas from "./components/CardCanvas";
import BottomBar from "./components/BottomBar";

const startCards = [
	"Delver of secrets // Insectile Aberration",
	"Halvar, God of Battle // Sword of the Realms",
	"Valki, God of Lies // Tibalt, Cosmic Impostor",
	"Tergrid, God of Fright // Tergrid's Lantern",
	"Shatterskull Smashing // Shatterskull, the Hammer Pass",
	"Elesh Norn // The Argent Etchings",
	"Invasion of Innistrad // Deluge of the Dead",
	"Invasion of Zendikar // Awakened Skyclave",
	"Fable of the Mirror-Breaker // Reflection of Kiki-Jiki",
	"Sephiroth, Fabled SOLDIER // Sephiroth, One-Winged Angel"
];


const cardWidth = 750;
const cardHeight = 1050;

const validCardLayouts = ["modal_dfc", "transform"];
const defaultFaces = {
	frontFace: {},
	backFace: {},
};

function App() {
	const [faces, setFaces] = useState(defaultFaces);
	const [once, setOnce] = useState(true);
	const [error, setError] = useState(false);
	const [drawTopImage, setDrawTopImage] = useState(true);
	const [drawBottomImage, setDrawBottomImage] = useState(true);
	const [addBleedBorder, setBleedBorder] = useState(false);

	const selectCard = (cardName) => {
		fetch(`https://api.scryfall.com/cards/search?q=${cardName}`)
			.then((response) => response.json())
			.then((cardData) => {
				if (validCardLayouts.indexOf(cardData.data[0].layout) >= 0) {
					if (
						cardData.data[0].card_faces[0] &&
						cardData.data[0].card_faces[1]
					) {
						setFaces({
							frontFace: cardData.data[0].card_faces[0],
							backFace: cardData.data[0].card_faces[1],
						});
						setError(false);
					}
				} else {
					setError(`${cardName} is not a double faced card`);
				}
			})
			.catch((e) =>
				console.error(`Error getting card data for ${cardName} : ${e.stack}`)
			);
	};

	useEffect(() => {
		if (once) {
			setOnce(false);
			const index = Math.round(Math.random() * startCards.length);
			console.log(`Setting default index to ${index}`);
			selectCard(startCards[index]);
		}
	}, [once]);
	//
	function toggleDrawTop() {
		setDrawTopImage(!drawTopImage);
	}
	function toggleDrawBottom() {
		setDrawBottomImage(!drawBottomImage);
	}
	function toggleBleedBorder() {
		setBleedBorder(!addBleedBorder);
	}

	return (
		<div className="App">
			<div className="topBar">DFC Proxy Generator</div>
			<SearchBar selectCard={selectCard} />
			{error === "" ? "" : <div className="error">{error}</div>}
			<CardCanvas
				frontFace={faces.frontFace}
				backFace={faces.backFace}
				height={addBleedBorder ? cardHeight + 72 : cardHeight}
				width={addBleedBorder ? cardWidth + 72 : cardWidth}
				drawTop={drawTopImage}
				drawBottom={drawBottomImage}
				addBleedBorder={addBleedBorder}
			/>
			<div>Draw top image <input type="checkbox" checked={drawTopImage} onClick={toggleDrawTop}></input></div>
			<div>Draw bottom image <input type="checkbox" checked={drawBottomImage} onClick={toggleDrawBottom}></input></div>
			<div>Draw bleed borderd<input type="checkbox" checked={addBleedBorder} onClick={toggleBleedBorder}></input></div>
			
			<BottomBar />
		</div >
	);
	// <div>Add bleed border <input type="checkbox" checked={addBleedBorder} onClick={toggleBleedBorder}></input></div>
}

export default App;
